import React, { useEffect, useRef } from 'react';
import { useTypewriter } from '../hooks/useTypewriter';

const Hero = () => {
  const heroBackgroundRef = useRef(null);
  const { displayText } = useTypewriter(['solução.', 'transformação.', 'resultado.'], 100, 50, 2000);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const parallaxSpeed = 0.5;

      if (heroBackgroundRef.current && scrolled < window.innerHeight) {
        heroBackgroundRef.current.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const headerHeight = 100;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-background" ref={heroBackgroundRef}></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge fade-in">
            <span>Conectando Ideias, Criando Soluções.</span>
          </div>
          <h1 className="hero-title fade-in-up">
            <span style={{ whiteSpace: 'nowrap' }}>Somos mais que tecnologia,</span><br />
            somos <span className="gradient-text">{displayText}</span><span className="cursor"></span>
          </h1>
          <p className="hero-subtitle fade-in-up">
            Transformamos ideias em realidade através de soluções tecnológicas inovadoras, conectando inovação e eficiência para impulsionar seu negócio.
          </p>
          <div className="hero-ctas fade-in-up">
            <a href="#contact" className="btn-primary btn-large" onClick={(e) => handleSmoothScroll(e, '#contact')}>Solicite sua Solução</a>
            <a href="#projects" className="btn-secondary btn-large" onClick={(e) => handleSmoothScroll(e, '#projects')}>Ver Nossos Projetos</a>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Hero;

